import Image from "next/image";
export default function HeroBg() {
  return (
    <div className="absolute h-0 w-full overflow-hidden pb-[57%]">
      <Image
        src="https://web-cdn.rockflow.tech/h5/activities/stock-rebate/grad-bg.png"
        alt="grad-bg"
        fill
        sizes="100vw" />
      <div
        className="absolute bottom-20 left-1/2 h-[511px] w-[603px]"
        style={{
          transform: "translate(-50%,0%)",
          background:
            "radial-gradient(50% 50% at 50% 50%, #C06FFF 0%, rgba(174, 111, 255, 0) 100%)",
        }}
      ></div>
    </div>
  );
}
